import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpEventType,
  HttpEvent,
  HttpResponse
} from "@angular/common/http";
import { map, tap, last } from "rxjs/operators";
import { BehaviorSubject } from "rxjs";
import {GlobalConstants} from './global-constants';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: "root"
})
export class UploaderService {
  public progressSource = new BehaviorSubject<number>(0);

  constructor(private http: HttpClient) {}

  upload(file: File, token: string) {
    let formData = new FormData();
    formData.append("file", file);
    formData.append("token", token);

    const req = new HttpRequest(
      'POST',
      environment.API_URL + '/upload-file',
      formData,
      {
        reportProgress: true
      }
    );

    return this.http.request(req).pipe(
      map(event => this.getEventMessage(event, file)),
      tap((envelope: any) => this.processProgress(envelope)),
      last()
    );
  }

  processProgress(envelope: any): void {
    if (typeof envelope === 'number') {
      this.progressSource.next(envelope);
    }
  }

  private getEventMessage(event: HttpEvent<any>, file: File) {
    switch (event.type) {
      case HttpEventType.Sent:
        return `Uploading file "${file.name}"`;
      case HttpEventType.UploadProgress:
        return Math.round((100 * event.loaded) / event.total);
      case HttpEventType.Response:
        /*
        {
          "success": true,
          "filename": "file-1583337555559.jpg",
          "path": "uploads/file-1583337555559.jpg"
        }
        */
        if (event.body.success)
          return { "filename": event.body.filename,
                    "token": event.body.token
          };
        else
          return null;
      default:
        return `File "${file.name}" surprising upload event: ${event.type}.`;
    }
  }
}
